// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"cdd44f3b","443":"31eb1b6b"}[chunkId] + ".chunk.js";
};